import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioDefault = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_i_9343_301)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 1,
				y: 1,
				width: 20,
				height: 20,
				rx: 10,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 20,
			height: 20,
			rx: 10,
			stroke: "#CBC6C5"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_i_9343_301",
			x: .5,
			y: .5,
			width: 21,
			height: 22,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect1_innerShadow_9343_301"
				})
			]
		}) })
	]
});
export default SvgRadioDefault;
